import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { formatColumnDate, dateFilterParams } from '../lib/utils';

const defaultFilterParams = {
  newRowsAction: 'keep',
};

export default [
  {
    cellClass: 'ticker-cell',
    field: 'date_ex',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      inRangeInclusive: true,
    },
    headerName: 'Ex-Date',
    initialSort: 'asc' as ColDef['initialSort'],
    initialWidth: 110,
    minWidth: 100,
    valueFormatter: ({ data }) => formatColumnDate(data.date_ex),
    valueGetter: ({ data }) => {
      if (!data.date_ex) return null;

      return data.date_ex;
    },
  },
  {
    cellClass: 'ticker-cell company-name-cell',
    cellRenderer: ({ data }: any) => {
      return (
        <div className="company-name-cell">
          <span>{data.name}</span>
          {data.logo && <img alt="" className="bz-ag-table__company-image" loading="lazy" src={data.logo}></img>}
        </div>
      );
    },
    cellRendererParams: {
      hideOnInitialTicker: true,
    },
    field: 'name',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Company',
    initialWidth: 180,
    minWidth: 160,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    field: 'ticker',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    initialWidth: 80,
    minWidth: 70,
  },
  {
    cellClass: 'ticker-cell',
    field: 'exchange',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    initialWidth: 110,
    minWidth: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'ratio',
    filter: 'priceFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      values: [
        {
          label: 'Reverse Split',
          rules: (value: string) => {
            if (!value) return false;

            const [first, second] = value.split(':');

            return first < second;
          },
        },
        {
          label: 'Forward Split',
          rules: (value: string) => {
            if (!value) return false;

            const [first, second] = value.split(':');

            return first >= second;
          },
        },
      ],
    },
    headerName: 'Split Ratio',
    initialWidth: 120,
    minWidth: 110,
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_announced',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      inRangeInclusive: true,
    },
    headerName: 'Date Announced',
    initialWidth: 140,
    minWidth: 130,
    valueFormatter: ({ data }) => formatColumnDate(data.date_announced),
    valueGetter: ({ data }) => {
      if (!data.date_announced) return null;

      return data.date_announced;
    },
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_recorded',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      inRangeInclusive: true,
    },
    headerName: 'Date Recorded',
    initialWidth: 140,
    minWidth: 130,
    valueFormatter: ({ data }) => formatColumnDate(data.date_recorded),
    valueGetter: ({ data }) => {
      if (!data.date_recorded) return null;

      return data.date_recorded;
    },
  },
  {
    cellClass: 'ticker-cell',
    field: 'date_distribution',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      inRangeInclusive: true,
    },
    headerName: 'Distribution Date',
    initialWidth: 150,
    minWidth: 140,
    valueFormatter: ({ data }) => formatColumnDate(data.date_distribution),
    valueGetter: ({ data }) => {
      if (!data.date_distribution) return null;

      return data.date_distribution;
    },
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: () => {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href="https://www.benzinga.com/profile/portfolio/?action=login&utm_source=calendars" target="_blank">
          Get Alert
        </a>
      );
    },
    field: 'get_alert',
    headerName: 'Get Alert',
    initialWidth: 90,
    minWidth: 85,
    suppressAutoSize: true,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
  },
] as (ColDef | ColGroupDef)[];
